import { getResultyStatus } from "../helpers";

export function ResultyStatusBadge({ status }) {
  const resultyStatus = getResultyStatus(status);

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${resultyStatus.className}`}>
      {resultyStatus.label}
    </span>
  );
}
